import axios from 'axios';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import { PAGE_SIZE } from 'services/constants/env';
import { getJobsRequest, getJobsSuccess } from './reducer';
import { refreshTokenByTimeOutSuccess, refreshTokenByTimeOutRequest } from '../auth/reducer';
import { TJobsRequest, TJobsResponsePayload } from './types';

function* getJobsWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TJobsResponsePayload = yield call(api.classifications.getJobs);
		yield put(getJobsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(error?.response?.data?.message ?? error.message ?? 'Error', 'error');
		}
	}
}

export function* classificationsSaga() {
	yield takeEvery(getJobsRequest.type, getJobsWorker);
}
